module.exports = __webpack_public_path__ + "static/img/home004.fc761de.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/home004.png
// module id = t3Tb
// module chunks = 0